import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';

export const claimGroupsService = {
  all: (companyId, queryParams = null) => {
    return fetch(`/api/time_tracking/companies/${companyId}/claim_groups?${queryParams}`, request.get);
  }
};
